import FullWidthLayout from "@/layouts/FullWidthLayout";
import KSalesmenTable from "kinnect-front/KSalesmen/KSalesmenTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { Salesman } from "kinnect-models";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "SalesmenPage",

	metaInfo: { title: "Salesmen" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		salesmen: [],
		search: ""
	} ),

	computed: {
		numSalesmen() {
			return this.salesmen.length;
		},

		toolbarActions() {
			if ( this.$can( "add_salesmen" ) ) {
				return {
					icon: "add_circle",
					text: "Add Salesman",
					to: { name: "salesmanAdd" },
					tooltip: "Add a new salesman"
				};
			}
		}
	},

	watch: {
		numSalesmen( numSalesmen ) {
			const suffix = numSalesmen === 1 ? "salesman" : "salesmen";

			this.$store.dispatch( "breadcrumbs/setDetails", `${numSalesmen} ${suffix}` );
		}
	},

	methods: {
		async fetchSalesmen() {
			this.salesmen = await Salesman.get();
		},

		async fetch() {
			await this.fetchSalesmen();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KSalesmenTable
					items={this.salesmen}
					loading={this.$wait.is( "get salesmen" )}
					search={this.search}
				></KSalesmenTable>
			</VCard>
		</FullWidthLayout>;
	}
};
